import request from '@/utils/request'
import axios from 'axios'
import store from '@/store'

export function loadReportCharts(filter) {
  const datajson = JSON.stringify(filter)
  return request({
    url: '/reports/reportsdata',
    method: 'post',
    data: datajson,
    timeout: 35000,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function printReport(filter) {
  const datajson = JSON.stringify(filter)
  return request({
    url: '/reports/printreport',
    method: 'post',
    data: datajson,
    timeout: 35000,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function downloadStaticReport(id) {
  const datajson = JSON.stringify({ id: id })
  return request({
    url: '/reports/downloadstaticreport',
    method: 'post',
    data: datajson,
    timeout: 35000,
    headers: {
      'Content-Type': 'application/json'
    },
    responseType: 'blob'
  })
}

export function DownloadGenericTableAsXlsx(arrayList) {
  return axios.post(window._env_.VUE_APP_BRAINS_API + '/reports/DownloadGenericTableAsXlsx',
    arrayList,
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + store.state.user.token
      },
      responseType: 'arraybuffer'
    }
  )
}
